import { render, staticRenderFns } from "./GeographicalSetup.vue?vue&type=template&id=24ee19e2&scoped=true&"
import script from "./GeographicalSetup.vue?vue&type=script&lang=js&"
export * from "./GeographicalSetup.vue?vue&type=script&lang=js&"
import style0 from "./GeographicalSetup.vue?vue&type=style&index=0&id=24ee19e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ee19e2",
  null
  
)

export default component.exports